var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1zM8 13c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 3c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v1c0 .6.4 1 1 1h1c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1h-2v3c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-3H2c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h1c.6 0 1-.4 1-1V3zm10 6H6v7h8V9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgPrinter;